import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { RoutesService } from "./routes.service";


@Injectable()
export class BootboxService {

    constructor(private translate: TranslateService,
        private router: Router,
        private routeService: RoutesService,
        private activatedRoute: ActivatedRoute) {
    }

    i18nAlert(key: string, val: string = '') {

        let mex = this.getLabel(key);
        if (val == '') {
            let procededToBuy = this.getLabel('continua_gli_acqisti');
            let goToCart = this.getLabel('header_two_cart_button_go_cart');

            let res: boolean;
            let bot = this;

            bootbox.dialog({
                message: mex,
                backdrop: true,
                buttons: {
                    confirm: {
                        label: goToCart,
                        callback: function () {
                            bot.navigateToCart();
                        }
                    },
                    cancel: {
                        label: procededToBuy,
                        className: 'btn btn-primary'
                    }
                }
            });
        }
        else {
            bootbox.alert({
                message: mex,
                backdrop: true,
            });
        }

    }

    navigateToCart() {
        var Url = this.routeService.getRoutePath('CARRELLO')[0];
        this.router.navigate([Url]);
    }

    getLabel(label) {
        let message;

        this.translate.get(label, this.translate).subscribe((res: string) => {
            message = res;
        });
        return message;
    }

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/bootbox.service.ts